"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var Body_1 = __importDefault(require("./Body/Body"));
var Header_1 = __importDefault(require("./Header/Header"));
var Footer_1 = __importDefault(require("./Footer/Footer"));
var Calendar = /** @class */ (function (_super) {
    __extends(Calendar, _super);
    function Calendar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.goToToday = function () {
            var reducer = _this.props.reducer;
            var action = 'goToToday';
            var today = moment_timezone_1.default().locale('en').startOf('day').startOf('month');
            var payload = { date: today };
            reducer({ action: action, payload: payload });
        };
        _this.previous = function (unit) {
            var _a = _this.props, month = _a.month, reducer = _a.reducer;
            var action = 'next';
            var clone = month.clone();
            var previous = clone.subtract(1, unit);
            var payload = { date: previous };
            reducer({ action: action, payload: payload });
        };
        _this.next = function (unit) {
            var _a = _this.props, month = _a.month, reducer = _a.reducer;
            var action = 'next';
            var clone = month.clone();
            var next = clone.add(1, unit);
            var payload = { date: next };
            reducer({ action: action, payload: payload });
        };
        _this.select = function (date) {
            var reducer = _this.props.reducer;
            var action = 'selectDay';
            var payload = { date: date };
            reducer({ action: action, payload: payload });
        };
        _this.ok = function () {
            var reducer = _this.props.reducer;
            var action = 'ok';
            var payload = {};
            reducer({ action: action, payload: payload });
        };
        _this.cancel = function () {
            var reducer = _this.props.reducer;
            var action = 'cancel';
            var payload = {};
            reducer({ action: action, payload: payload });
        };
        _this.reset = function () {
            var reducer = _this.props.reducer;
            var action = 'reset';
            var payload = {};
            reducer({ action: action, payload: payload });
        };
        return _this;
    }
    Calendar.prototype.render = function () {
        var _a = this.props, month = _a.month, highlightWeekends = _a.highlightWeekends, selected = _a.selected, to = _a.to, from = _a.from, showYears = _a.showYears, disablePast = _a.disablePast, disableFuture = _a.disableFuture, disableWeekends = _a.disableWeekends, enabledBetween = _a.enabledBetween, closeOnSelection = _a.closeOnSelection, range = _a.range, viewType = _a.viewType, i18nShowToday = _a.i18nShowToday, i18nOk = _a.i18nOk, i18nCancel = _a.i18nCancel, i18nClear = _a.i18nClear;
        return (React.createElement("div", { className: "calendar-overlay-wrap" },
            React.createElement(Header_1.default, { month: month, next: this.next, previous: this.previous, years: showYears, range: range }),
            React.createElement(Body_1.default, { month: month, showYears: showYears, highlightWeekends: highlightWeekends, select: this.select, selected: selected, to: to, from: from, range: range, disablePast: disablePast, disableFuture: disableFuture, disableWeekends: disableWeekends, enabledBetween: enabledBetween }),
            React.createElement(Footer_1.default, { goToToday: this.goToToday, range: range, ok: this.ok, cancel: this.cancel, reset: this.reset, to: to, from: from, closeOnSelection: closeOnSelection, viewType: viewType, i18nShowToday: i18nShowToday, i18nOk: i18nOk, i18nCancel: i18nCancel, i18nClear: i18nClear })));
    };
    return Calendar;
}(React.Component));
exports.default = Calendar;
